<div class="address-search" [class.isDisabled]="disabled">
  <nb-form-field>
    <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
    <input
      type="text"
      nbInput
      fullWidth
      id="address_search"
      autocomplete="off"
      [formControl]="searchControl"
      [nbAutocomplete]="addressAuto"
      placeholder="{{ 'input.addressSearch.placeholder' | translate }}"
    />
    <nb-icon
      *ngIf="searching"
      nbSuffix
      icon="loader-outline"
      pack="eva"
      class="spinning"
    ></nb-icon>
  </nb-form-field>

  <nb-autocomplete
    #addressAuto
    [handleDisplayFn]="displayFn"
    (selectedChange)="onSelect($event)"
  >
    <nb-option *ngFor="let suggestion of suggestions" [value]="suggestion">
      {{ suggestion.label }}
    </nb-option>
  </nb-autocomplete>

  <p class="hint">{{ "input.addressSearch.hint" | translate }}</p>
</div>
